import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar-pest',
  templateUrl: './sidebar-pest.component.html',
  styleUrls: ['./sidebar-pest.component.scss']
})
export class SidebarPestComponent {

  @Input() plots2: any[] = [];
  @Input() selectedPlot: string = '';
  @Output() plotSelected = new EventEmitter<{ plotCode: string, plot: any, location: string }>();


  onSelectPlot(plotCode: string, plot: any, location: string) {
    this.plotSelected.emit({ plotCode, plot, location });
  }
}
